/**
 * Helper function to format tier names for display
 */
export function formatTierName(tier: string): string {
  switch (tier) {
    case 'premium_tier':
      return 'Premium';
    case 'whatsapp_tier':
      return 'WhatsApp Verification';
    case 'free_tier':
      return 'Free';
    default:
      return tier;
  }
}

/**
 * Helper function to format source names for display
 */
export function formatSourceName(source: string | null): string {
  switch (source) {
    case 'admin':
      return 'Admin Granted';
    case 'stripe':
      return 'Stripe';
    case 'free':
    case 'internal':
      return 'Free tier';
    default:
      return source || 'Unknown';
  }
}
